(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["cart-summary"] && !Shopify.designMode) return;
  try {
    (function () {
    var POLL_MS = 400;
    var GATED_CLASS = 'cart-page__checkout--gated';

    // See this file's own doc comment above for the full "why" behind
    // every decision here — polling instead of trusting an event, the
    // fail-open timeout, "loaded" and "valid" being the same check, and
    // the CSS lock class this always toggles in lockstep with `.disabled`.
    class CartSummaryBlock extends HTMLElement {
      connectedCallback() {
        var checkoutButton = this.querySelector('[data-requires-delivery-date]');
        // Feature flag is off for this instance — nothing to wire up.
        if (!checkoutButton) return;

        var attributeKey = checkoutButton.dataset.deliveryDateKey;
        var timeoutMs = (parseInt(checkoutButton.dataset.deliveryDateTimeout, 10) || 8) * 1000;
        var selector = 'input[name="attributes[' + attributeKey + ']"]';
        var form = checkoutButton.closest('form');
        var scope = form || document;
        var resolved = false;

        var setGated = function (gated) {
          checkoutButton.disabled = gated;
          checkoutButton.classList.toggle(GATED_CLASS, gated);
        };

        var sync = function () {
          var field = scope.querySelector(selector);
          var hasValue = !!(field && field.value && field.value.trim() !== '');
          setGated(!hasValue);
          if (hasValue) resolved = true;
        };

        sync();

        var pollId = window.setInterval(sync, POLL_MS);
        // Cheap best-effort fast path for a widget that DOES fire real
        // events — the poll above is what actually guarantees correctness.
        document.addEventListener('input', sync, true);
        document.addEventListener('change', sync, true);

        window.setTimeout(function () {
          if (resolved) return;
          window.clearInterval(pollId);
          setGated(false);
          console.warn(
            '[cart-summary] "' + selector + '" never reported a value within ' +
              timeoutMs / 1000 +
              's — unlocking checkout. Confirm the delivery-date app is installed and ' +
              '"delivery_date_attribute_key" on the cart-summary block matches the cart ' +
              'attribute it actually writes to.',
          );
        }, timeoutMs);
      }
    }

    if (!customElements.get('cart-summary-block')) {
      customElements.define('cart-summary-block', CartSummaryBlock);
    }
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["product-add-to-cart"] && !Shopify.designMode) return;
  try {
    (function () {
    class ProductAddToCartBlock extends HTMLElement {
      connectedCallback() {
        this.button = this.querySelector('[data-add-to-cart-button]');
        this.form = this.closest('form');
        if (!this.button || !this.form) return;

        this.form.addEventListener('variant:change', this._onVariantChange.bind(this));

        // Same "only intercept if GoarCart actually loaded" guard as
        // snippets/upsell.liquid — the <button name="add"> + this
        // <form>'s real action/method carry a plain, fully-functional
        // POST otherwise (see AGENTS.md § Cart).
        if (!window.GoarCart) return;
        if (this.form.dataset.addToCartBound) return;
        this.form.dataset.addToCartBound = 'true';
        this.form.addEventListener('submit', this._onSubmit.bind(this));
      }

      _onVariantChange(event) {
        var variant = event.detail && event.detail.variant;
        var available = !!(variant && variant.available);
        this.button.disabled = !available;
        var label = this.button.querySelector('.button__label');
        if (label) {
          label.textContent = available ? this.dataset.availableLabel : this.dataset.soldOutLabel;
        }
      }

      _onSubmit(event) {
        event.preventDefault();
        if (this.form.classList.contains('is-adding')) return;

        var idInput = this.form.querySelector('input[name="id"]');
        if (!idInput || !idInput.value) return;

        var properties = {};
        this.form.querySelectorAll('[name^="properties["]').forEach(function (field) {
          if (field.disabled) return;
          var match = field.name.match(/^properties\[(.+)\]$/);
          if (match) properties[match[1]] = field.value;
        });

        this.form.classList.add('is-adding');
        this.button.disabled = true;

        window.GoarCart.addItem(idInput.value, 1, properties)
          .catch(function () {
            // GoarCart already dispatched 'cart:error' — nothing extra to
            // do here besides not leaving the button stuck disabled.
          })
          .finally(
            function () {
              this.form.classList.remove('is-adding');
              // Only re-enable if the currently-selected combination is
              // still actually available — don't blindly clear a
              // sold-out disable that was already in effect before submit.
              var checked = this.form.querySelector('input[name="id"]');
              this.button.disabled = !checked || !checked.value;
            }.bind(this),
          );
      }
    }

    if (!customElements.get('product-add-to-cart-block')) {
      customElements.define('product-add-to-cart-block', ProductAddToCartBlock);
    }
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["product-delivery"] && !Shopify.designMode) return;
  try {
    (function () {
    // Only ever read LOCAL_DELIVERY off Buunto's response — STORE_PICKUP
    // is a different fulfillment method this theme doesn't offer here and
    // must never be used, even as a fallback when LOCAL_DELIVERY is
    // missing.
    var BUUNTO_ENDPOINT = 'https://datepicker.buunto.com/api/v1/cut_off_times';

    class ProductDeliveryBlock extends HTMLElement {
      connectedCallback() {
        var script = this.querySelector('[data-delivery-json]');
        var data = script ? JSON.parse(script.textContent) : {};
        this.variantDates = data.variantDates || {};
        this.productDate = data.productDate || null;

        this.dateSource = this.dataset.dateSource;
        this.dateDisplay = this.dataset.dateDisplay;
        this.shopDomain = this.dataset.shopDomain;
        // Bumped on every Buunto fetch kicked off below; a response is
        // only applied if it's still the MOST RECENT one requested — see
        // this file's top comment on why (a slow response for a variant
        // the shopper has already clicked away from must never clobber
        // the text a newer, faster response already set).
        this._buuntoRequestId = 0;

        this.statusEl = this.querySelector('[data-delivery-status]');
        this.statusTextEl = this.querySelector('[data-delivery-status-text]');

        if (this.dateSource === 'buunto' && this.dataset.initialVariantAvailable === 'true') {
          this._resolveBuuntoDate(this.dataset.initialVariantId);
        }

        this.form = this.closest('form');
        if (!this.form) return;

        this.form.addEventListener('variant:change', this._onVariantChange.bind(this));
      }

      _onVariantChange(event) {
        var variant = event.detail && event.detail.variant;
        if (!variant || !this.statusEl || !this.statusTextEl) return;

        var available = !!variant.available;
        this.statusEl.classList.toggle('product-delivery-block__status--unavailable', !available);

        if (!available) {
          this.statusTextEl.textContent = this.dataset.outOfStockText;
          return;
        }

        if (this.dateSource === 'buunto') {
          // No local JSON to look up (see this file's top comment) —
          // show the "no date yet" fallback immediately, then patch in
          // the real date once the fetch below resolves, exactly like
          // the initial page load does.
          this.statusTextEl.textContent = this.dataset.inStockNoDateText;
          this._resolveBuuntoDate(variant.id);
          return;
        }

        var date = this.variantDates[String(variant.id)] || this.productDate;
        this._applyDate(date);
      }

      _resolveBuuntoDate(variantId) {
        if (!variantId || !this.shopDomain) return;

        var requestId = ++this._buuntoRequestId;
        var url =
          BUUNTO_ENDPOINT +
          '?shop=' +
          encodeURIComponent(this.shopDomain) +
          '&productVariantIds=' +
          encodeURIComponent(variantId);

        fetch(url)
          .then(
            function (response) {
              return response.ok ? response.json() : null;
            }.bind(this),
          )
          .then(
            function (result) {
              // A newer variant:change already fired its own fetch —
              // this response is for a variant the shopper has since
              // moved away from, so it's discarded rather than applied.
              if (requestId !== this._buuntoRequestId) return;
              var local = result && result.LOCAL_DELIVERY;
              this._applyDate(local && local.firstAvailableDate);
            }.bind(this),
          )
          .catch(function () {
            // Network/API failure: leave whatever fallback text is
            // already showing (in_stock_no_date_text) rather than
            // surfacing an error state — same graceful-degradation
            // shape as a genuinely unset metafield.
          });
      }

      _applyDate(date) {
        if (!this.statusTextEl) return;
        if (date) {
          this.statusTextEl.textContent = this.dataset.inStockText.replace('[date]', this._displayDate(date));
        } else {
          this.statusTextEl.textContent = this.dataset.inStockNoDateText;
        }
      }

      // Mirrors this file's own Liquid `date_display` transform: `[date]`
      // resolves to the raw date as-is, or — for `week_commencing` — to
      // that same ISO week's Monday instead, so a variant switch can
      // never flip formatting mid-session relative to the server-rendered
      // initial paint.
      _displayDate(iso) {
        if (this.dateDisplay === 'week_commencing') {
          iso = this._weekCommencingIso(iso);
        }
        return this._formatDate(iso);
      }

      // ISO weekday via UTC getDay() (0=Sunday..6=Saturday), converted to
      // the same Monday=1..Sunday=7 numbering as Liquid's `%u` so the
      // `weekday - 1` day offset matches exactly.
      _weekCommencingIso(iso) {
        var d = new Date(iso + 'T00:00:00Z');
        var isoWeekday = d.getUTCDay() === 0 ? 7 : d.getUTCDay();
        d.setUTCDate(d.getUTCDate() - (isoWeekday - 1));
        return d.toISOString().slice(0, 10);
      }

      // Reproduces Liquid's `%a %-d %b` formatting (e.g. "Mon 7 Sep") —
      // weekday, bare day number, month, always in that fixed order. Does
      // NOT hand that ordering to `Intl`/`toLocaleDateString` (its
      // weekday/day/month FIELD ORDER is locale-dependent — en-US puts
      // the month before the day) even though it supplies the individual
      // weekday/month strings, so the client-rendered date can't drift
      // from what Liquid already rendered server-side for the initial
      // paint. Parses as literal UTC midnight and formats with
      // `timeZone: 'UTC'` throughout — `new Date('2026-09-07')` is
      // already UTC-midnight per spec, but formatting that with the
      // shopper's LOCAL timezone instead would reintroduce exactly the
      // off-by-one-day risk (in timezones behind UTC) this is avoiding.
      _formatDate(iso) {
        var d = new Date(iso + 'T00:00:00Z');
        var weekday = d.toLocaleDateString('en-US', { weekday: 'short', timeZone: 'UTC' });
        var day = d.getUTCDate();
        var month = d.toLocaleDateString('en-US', { month: 'short', timeZone: 'UTC' });
        return weekday + ' ' + day + ' ' + month;
      }
    }

    if (!customElements.get('product-delivery-block')) {
      customElements.define('product-delivery-block', ProductDeliveryBlock);
    }
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["product-summary"] && !Shopify.designMode) return;
  try {
    (function () {
    // Byte-for-byte copy of variant-picker.liquid's own money formatter —
    // see this file's top comment on why this is a deliberate duplicate,
    // not a shared import.
    function formatWithDelimiters(cents, precision, thousands, decimal) {
      thousands = thousands === undefined ? ',' : thousands;
      decimal = decimal === undefined ? '.' : decimal;
      var amount = (cents / 100).toFixed(precision);
      var parts = amount.split('.');
      var whole = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands);
      var fraction = parts[1] ? decimal + parts[1] : '';
      return whole + fraction;
    }

    function formatMoney(cents, format) {
      var placeholder = /\{\{\s*(\w+)\s*\}\}/;
      var match = placeholder.exec(format || '');
      var key = match ? match[1] : 'amount';
      var value;
      switch (key) {
        case 'amount_no_decimals':
          value = formatWithDelimiters(cents, 0);
          break;
        case 'amount_with_comma_separator':
          value = formatWithDelimiters(cents, 2, '.', ',');
          break;
        case 'amount_no_decimals_with_comma_separator':
          value = formatWithDelimiters(cents, 0, '.', ',');
          break;
        default:
          value = formatWithDelimiters(cents, 2);
      }
      return match ? format.replace(placeholder, value) : '$' + value;
    }

    class ProductSummaryBlock extends HTMLElement {
      connectedCallback() {
        this.widthPosition = parseInt(this.dataset.widthPosition, 10) || null;
        this.lengthPosition = parseInt(this.dataset.lengthPosition, 10) || null;
        this.preferencePosition = parseInt(this.dataset.preferencePosition, 10) || null;
        // Native/unmatched option positions (see this file's top comment)
        // — a plain comma list since option NAMES aren't in the
        // lightweight per-variant JSON variant:change carries, only
        // position-ordered values, same reason width/length/preference
        // are passed as positions instead of names too.
        this.otherPositions = (this.dataset.otherPositions || '')
          .split(',')
          .map(function (p) { return parseInt(p, 10); })
          .filter(function (p) { return !isNaN(p); });
        this.moneyFormat = this.dataset.moneyFormat;

        var script = this.querySelector('[data-summary-contents-json]');
        this.contentsByVariant = script ? JSON.parse(script.textContent) : {};

        this.metaEl = this.querySelector('[data-summary-meta]');
        this.dividerEl = this.querySelector('[data-summary-divider]');
        this.contentsEl = this.querySelector('[data-summary-contents]');
        this.priceEl = this.querySelector('[data-summary-price]');

        this.form = this.closest('form');
        if (this.form) this.form.addEventListener('variant:change', this._onVariantChange.bind(this));
      }

      _onVariantChange(event) {
        var variant = event.detail && event.detail.variant;
        if (!variant) return;

        var sizeParts = [];
        if (this.widthPosition) sizeParts.push(variant.options[this.widthPosition - 1]);
        if (this.lengthPosition) sizeParts.push(variant.options[this.lengthPosition - 1]);
        var metaText = sizeParts.filter(Boolean).join(' × ');

        // Same order the server render builds meta_text in: size, then
        // every native/unmatched option, then Preference last.
        this.otherPositions.forEach(
          function (position) {
            var value = variant.options[position - 1];
            if (!value) return;
            metaText = metaText ? metaText + ' · ' + value : value;
          },
        );

        if (this.preferencePosition) {
          var preferenceValue = variant.options[this.preferencePosition - 1];
          if (preferenceValue) {
            metaText = metaText ? metaText + ' · ' + preferenceValue : preferenceValue;
          }
        }

        var contents = this.contentsByVariant[String(variant.id)] || '';

        this.metaEl.textContent = metaText;
        this.contentsEl.textContent = contents;
        this.dividerEl.hidden = !(metaText && contents);
        this.priceEl.textContent = formatMoney(variant.price, this.moneyFormat);
      }
    }

    if (!customElements.get('product-summary-block')) {
      customElements.define('product-summary-block', ProductSummaryBlock);
    }
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["product-upsells"] && !Shopify.designMode) return;
  try {
    // "Add all N" — clicks every row's OWN add button (snippets/upsell.liquid's
  // javascript-tag bundle, loaded once globally, owns the actual
  // GoarCart.addItem call and that row's checkmark confirmation) rather
  // than adding a second cart code path here. Rows here render with
  // `no_form: true` (see this file's top comment) so there's no
  // `<form>`/`requestSubmit()` to reach for — clicking the button is the
  // one trigger that works identically whether a row is `no_form` or not.
  document.querySelectorAll('[data-upsell-add-all]').forEach(function (button) {
    button.addEventListener('click', function () {
      var container = button.closest('[data-product-upsells]');
      if (!container) return;

      container.querySelectorAll('[data-upsell-add]').forEach(function (addButton) {
        addButton.click();
      });
    });
  });
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["variant-picker"] && !Shopify.designMode) return;
  try {
    (function () {
    // Minimal money formatter fed by `shop.money_format` — this theme has
    // no `Shopify.formatMoney` equivalent yet (see this file's top
    // comment). Supports the 4 placeholders Shopify's own format-string
    // docs define; anything else falls back to a plain 2-decimal amount.
    function formatWithDelimiters(cents, precision, thousands, decimal) {
      thousands = thousands === undefined ? ',' : thousands;
      decimal = decimal === undefined ? '.' : decimal;
      var amount = (cents / 100).toFixed(precision);
      var parts = amount.split('.');
      var whole = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands);
      var fraction = parts[1] ? decimal + parts[1] : '';
      return whole + fraction;
    }

    function formatMoney(cents, format) {
      var placeholder = /\{\{\s*(\w+)\s*\}\}/;
      var match = placeholder.exec(format || '');
      var key = match ? match[1] : 'amount';
      var value;
      switch (key) {
        case 'amount_no_decimals':
          value = formatWithDelimiters(cents, 0);
          break;
        case 'amount_with_comma_separator':
          value = formatWithDelimiters(cents, 2, '.', ',');
          break;
        case 'amount_no_decimals_with_comma_separator':
          value = formatWithDelimiters(cents, 0, '.', ',');
          break;
        default:
          value = formatWithDelimiters(cents, 2);
      }
      return match ? format.replace(placeholder, value) : '$' + value;
    }

    class VariantPicker extends HTMLElement {
      connectedCallback() {
        var script = this.querySelector('[data-variant-json]');
        this.variants = script ? JSON.parse(script.textContent) : [];
        this.optionCount = parseInt(this.dataset.optionCount || '0', 10);
        this.preferencePosition = this.dataset.preferencePosition
          ? parseInt(this.dataset.preferencePosition, 10)
          : null;
        this.preferenceBaseline = this.dataset.preferenceBaseline || null;
        // No JS-side literal fallback string here on purpose — a Liquid
        // double-curly placeholder token typed directly into a static
        // javascript-tag bundle reads as a real (unbalanced) Liquid
        // output tag to the parser, which is a real, confirmed way to
        // break the file (see AGENTS.md's warning on this class of bug,
        // and this file's own top comment). `shop.money_format` is a
        // Shopify-guaranteed setting that's never actually blank anyway,
        // and formatMoney() below already falls back to a plain
        // dollar-prefixed amount if `format` is ever falsy, so an
        // explicit default here would be redundant on top of that.
        this.moneyFormat = this.dataset.moneyFormat;
        this.form = this.closest('form');
        this.hiddenIdInput = this.form ? this.form.querySelector('input[name="id"]') : null;

        // Seed from whatever's already checked (server-rendered default
        // selection) rather than assuming position order — a position this
        // block doesn't manage stays `null` (wildcard) forever, see this
        // file's top comment on the "full option set" limitation.
        this.selected = new Array(this.optionCount).fill(null);
        this.querySelectorAll('input[type="radio"]:checked').forEach(
          function (input) {
            var group = input.closest('[data-option-position]');
            if (!group) return;
            var position = parseInt(group.dataset.optionPosition, 10);
            this.selected[position - 1] = input.value;
          }.bind(this),
        );

        this.addEventListener(
          'change',
          function (event) {
            if (!event.target.matches('input[type="radio"]')) return;
            this._onOptionChange(event.target);
          }.bind(this),
        );

        this._updateDeltas();
        this._updateAvailability();
        this._syncVariant();
        this._syncRequirements();
      }

      _onOptionChange(input) {
        var group = input.closest('[data-option-position]');
        if (!group) return;
        var position = parseInt(group.dataset.optionPosition, 10);
        this.selected[position - 1] = input.value;
        this._updateSelectedPills(group);
        this._updateDeltas();
        this._updateAvailability();
        this._syncVariant();
        if (group.dataset.role === 'preference') this._syncRequirements();
      }

      // `.is-selected` is only ever painted server-side (from the default
      // variant at render time — see snippets/variant-pill.liquid) — a
      // real, confirmed bug lived here: the radio's own native `checked`
      // state (and everything else in this file, which reads `:checked`
      // directly) updated correctly on click, but every pill kept
      // whatever `.is-selected` the server originally rendered, so
      // clicking a different pill moved the real selection without ever
      // moving the visible highlight. This just mirrors the group's real
      // `checked` state onto the class after every change.
      _updateSelectedPills(group) {
        group.querySelectorAll('.variant-pill').forEach(function (pill) {
          var radio = pill.querySelector('input[type="radio"]');
          pill.classList.toggle('is-selected', !!(radio && radio.checked));
        });
      }

      // Finds the variant matching `this.selected`, with `overrides`
      // (a { position: value } map) applied on top for a hypothetical
      // "what if this OTHER pill were picked instead" check — used by
      // both availability-marking and the delta baseline lookup below,
      // neither of which should mutate the real current selection.
      _findVariant(overrides) {
        var target = this.selected.slice();
        if (overrides) {
          Object.keys(overrides).forEach(function (position) {
            target[position - 1] = overrides[position];
          });
        }
        return this.variants.find(function (variant) {
          return variant.options.every(function (value, i) {
            return target[i] == null || target[i] === value;
          });
        });
      }

      _syncVariant() {
        var variant = this._findVariant();
        if (this.hiddenIdInput) {
          this.hiddenIdInput.value = variant ? variant.id : '';
          this.hiddenIdInput.dispatchEvent(new Event('change', { bubbles: true }));
        }
        if (this.form) {
          this.form.dispatchEvent(
            new CustomEvent('variant:change', { bubbles: true, detail: { variant: variant || null } }),
          );
        }
      }

      // Dims (doesn't disable — see this file's top comment) every pill
      // that has no in-stock variant combining ITS value with whatever's
      // currently selected everywhere else.
      _updateAvailability() {
        this.querySelectorAll('[data-option-position]').forEach(
          function (group) {
            var position = parseInt(group.dataset.optionPosition, 10);
            group.querySelectorAll('input[type="radio"]').forEach(
              function (input) {
                var overrides = {};
                overrides[position] = input.value;
                var match = this._findVariant(overrides);
                var pill = input.closest('.variant-pill');
                if (pill) pill.classList.toggle('is-unavailable', !match || !match.available);
              }.bind(this),
            );
          }.bind(this),
        );
      }

      // Live price delta on each Preference pill — see this file's top
      // comment for why this is computed here instead of a static setting.
      _updateDeltas() {
        if (this.preferencePosition == null) return;
        var baselineOverrides = {};
        if (this.preferenceBaseline != null) {
          baselineOverrides[this.preferencePosition] = this.preferenceBaseline;
        }
        var baseline = this._findVariant(baselineOverrides);
        if (!baseline) return;

        this.querySelectorAll('[data-pref-delta]').forEach(
          function (el) {
            var label = el.closest('.variant-pill');
            var input = label ? label.querySelector('input[type="radio"]') : null;
            if (!input) return;
            var overrides = {};
            overrides[this.preferencePosition] = input.value;
            var variant = this._findVariant(overrides);
            if (!variant) {
              el.textContent = '';
              return;
            }
            var delta = variant.price - baseline.price;
            if (delta === 0) {
              el.textContent = '';
              return;
            }
            var sign = delta > 0 ? '+' : '−';
            el.textContent = sign + formatMoney(Math.abs(delta), this.moneyFormat);
          }.bind(this),
        );
      }

      // Reveals/requires the requirements textarea only while the
      // currently-selected Preference pill is the one flagged
      // `data-triggers-requirements` (see this file's top comment).
      _syncRequirements() {
        var group = this.querySelector('[data-option-position][data-role="preference"]');
        var wrapper = this.querySelector('[data-requirements]');
        var textarea = this.querySelector('[data-requirements-field]');
        if (!group || !wrapper || !textarea) return;
        var selected = group.querySelector('input[type="radio"]:checked');
        var shouldShow = !!(selected && selected.dataset.triggersRequirements === 'true');
        wrapper.hidden = !shouldShow;
        textarea.required = shouldShow;
        textarea.disabled = !shouldShow;
      }
    }

    if (!customElements.get('variant-picker')) {
      customElements.define('variant-picker', VariantPicker);
    }
  })();
  } catch(e) { console.error(e); }
})();

})();
